import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import {
  PaginatedData,
  ProvinceData,
  QueryParams,
} from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

type UseGetProvinces<T> = {
  enabled?: boolean
  filters?: QueryParams
  noAuth?: boolean
  select?: (data: PaginatedData<ProvinceData[]>) => T
}

export const useGetProvinces = <T>({
  enabled,
  filters,
  noAuth,
  select,
}: UseGetProvinces<T>) =>
  useQuery({
    enabled,
    queryFn: () => api.provinces.getProvinces(filters, { noAuth }),
    queryKey: queriesKeys.provinces.getProvinces(filters, noAuth),
    refetchOnWindowFocus: false,
    select,
  })
